/* SOLSTICE — quick-view.js : modal produit via Section Rendering API */
(function () {
  'use strict';
  let modal;

  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      e.preventDefault();
      openQuickView(trigger.dataset.quickView);
    }
    const quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      quickAdd.disabled = true;
      try {
        await window.SolsticeCart.add({ id: parseInt(quickAdd.dataset.quickAdd, 10), quantity: 1 });
        document.dispatchEvent(new CustomEvent('cart:open-drawer'));
      } catch (err) { window.SolsticeUtils.toast(err.message); }
      quickAdd.disabled = false;
    }
  });

  async function openQuickView(url) {
    closeModal();
    modal = document.createElement('div');
    modal.className = 'modal is-open';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = `
      <div class="modal__overlay"></div>
      <div class="modal__panel">
        <button class="modal__close" aria-label="Close">✕</button>
        <div class="skeleton" style="height:340px"></div>
      </div>`;
    document.getElementById('QuickViewRoot').appendChild(modal);
    document.body.style.overflow = 'hidden';
    modal.querySelector('.modal__overlay').addEventListener('click', closeModal);
    modal.querySelector('.modal__close').addEventListener('click', closeModal);
    document.addEventListener('keydown', escHandler);

    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', 'quick-view');
      const res = await fetch(u);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-qv-root]');
      const panel = modal.querySelector('.modal__panel');
      panel.querySelector('.skeleton').remove();
      if (content) {
        panel.appendChild(content);
        bindQV(panel);
      }
    } catch (e) { closeModal(); }
  }

  function bindQV(panel) {
    const picker = panel.querySelector('[data-variant-picker]');
    const variants = picker ? JSON.parse(picker.querySelector('[data-variants-json]').textContent) : [];
    const form = panel.querySelector('[data-qv-form]');
    const idInput = form.querySelector('[data-variant-id]');
    const atc = form.querySelector('[data-atc-button]');

    if (picker) {
      picker.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        const fs = btn.closest('.vp');
        fs.querySelectorAll('[data-option-value]').forEach((b) => { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        fs.querySelector('[data-selected-value]').textContent = btn.dataset.optionValue;
        const opts = [...picker.querySelectorAll('.vp')].map((f) => f.querySelector('.is-selected')?.dataset.optionValue);
        const v = variants.find((va) => opts.every((o, i) => va[`option${i + 1}`] === o));
        if (v) {
          idInput.value = v.id;
          atc.disabled = !v.available;
          atc.textContent = v.available ? window.Solstice.strings.addToCart : window.Solstice.strings.soldOut;
          const priceBox = panel.querySelector('[data-price-wrapper] .price__now');
          if (priceBox) priceBox.textContent = window.SolsticeUtils.formatMoney(v.price);
        } else {
          atc.disabled = true;
          atc.textContent = window.Solstice.strings.unavailable;
        }
      });
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      atc.disabled = true;
      try {
        await window.SolsticeCart.add({ id: parseInt(idInput.value, 10), quantity: 1 });
        closeModal();
        document.dispatchEvent(new CustomEvent('cart:open-drawer'));
      } catch (err) {
        window.SolsticeUtils.toast(err.message);
        atc.disabled = false;
      }
    });
  }

  function escHandler(e) { if (e.key === 'Escape') closeModal(); }
  function closeModal() {
    if (modal) { modal.remove(); modal = null; document.body.style.overflow = ''; }
    document.removeEventListener('keydown', escHandler);
  }
})();
